import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-document-ring',
  templateUrl: 'document-ring.component.html'
})
export class DocumentRingComponent {
  constructor() {}
}
